import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-cream" data-id="element-80" data-mp="1hdupklvgf9bb">
      <div className="max-w-3xl mx-auto" data-id="element-81" data-mp="1cf03nb26x4mz">
        <div className="text-center mb-16" data-id="element-82" data-mp="1cgb8le7dgifo">
          <h2 className="text-3xl md:text-5xl font-display font-extrabold text-ink" data-id="element-83" data-mp="2a1ytb1ugtcbd">
            ❓ Frequently asked questions
          </h2>
        </div>
        <div className="space-y-4" data-id="element-84" data-mp="253xami0ybf0f">
          {faqs.map((faq, index) => <div key={faq.q} className="bg-white border border-silver-light rounded-xl overflow-hidden" data-id="element-85" data-mp="202rh4hzgvnpu" data-mpi={index}>
              <button type="button" className="w-full px-6 py-5 text-left flex items-center justify-between focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-inset" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-86" data-mp="1v7c8q5k8ak0t">
                <span className="font-bold text-lg text-ink pr-8" data-id="element-87" data-mp="1pkqmfmaci8qd">{faq.q}</span>
                <ChevronDown className={`text-brand transition-transform duration-200 ease-out shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-88" data-mp="1ap12rusmu7ot" />
              </button>
              <AnimatePresence initial={false} data-id="element-89" data-mp="16oqsw71pyx4o">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-90" data-mp="s047bnli1950">
                    <div className="px-6 pb-5 text-graphite border-t border-silver-light pt-4" data-id="element-91" data-mp="n1st70o68cgz">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}